<template >
  <div class="py-3 px-2 min-vh-100 text-left">
    <div v-if="!isStarted" class="main-content mx-auto">
      <!-- <header class="mb-4" v-if="lesson">
        <h3 class="font-weight-bold">{{ lesson.name }}</h3>
        <p class="text-muted" v-html="forceToJap(lesson.name_en)"></p>
      </header> -->

      <section class="mb-4">
        <div class="section-title">AI導師</div>
        <div class="card border-0 shadow-sm p-3 d-flex flex-row align-items-center">
          <div class="avatar-wrapper position-relative mr-4">
            <img :src="currentMentor.img" class="rounded avatar-img" :alt="currentMentor.name">
            <div class="audio-icon" @click="audio_play" v-if="currentMentor.audio_url"><i class="fas fa-volume-up"></i></div>
          </div>
          <div class="flex-grow-1">
            <div class="d-flex align-items-center flex-wrap">
              <h3 class="h4 mb-0 mr-3">{{ currentMentor.name }}</h3>
              <span class="badge custom-badge mr-2 label-icon">{{ currentMentor.accent }}</span>
              <span class="badge custom-badge mr-2 label-icon">{{ currentMentor.gender }}</span>
              <span class="badge custom-badge label-icon">{{ currentMentor.personality }}</span>
            </div>
          </div>
          <div class="text-secondary cursor-pointer" @click="openMentorPicker">
            更換導師 <i class="fas fa-chevron-right ml-1"></i>
          </div>
        </div>
      </section>

      <section class="mb-4">
        <div class="section-title">課程目標</div>
        <div class="card border-0 shadow-sm p-3">
          在本課程中進行至少 {{ oral_challenge_threshold }} 輪對話。
        </div>
      </section>

      <section class="mb-5">
        <div class="section-title">情境說明</div>
        <div class="card border-0 shadow-sm p-3">
          <p v-if="context">{{ context.guide }}</p>
        </div>
      </section>

      <div class="text-center">
        <button type="button" class="btn btn-danger btn-lg px-5 rounded-pill start-btn" @click="beginCourse">開始</button>
      </div>
    </div>
    <ChatContent
      v-else
      :name_code="currentMentor.tts_name"
      :force-course-chat="true"
      :force-prompt-id="targetCourseId"
      class="main-content mx-auto"
    />
  </div>
</template>

<script>
import api from '@/store/api'
import ChatContent from '@/views/AiHelper/ChatContent.vue'
import { mapGetters } from 'vuex'
export default {
  name: 'ai_course',
  components: {
    ChatContent
  },
  props: {
    courseId: {
      type: [String, Number],
      required: false,
      default: null
    }
  },
  data() {
    return {
      lesson: null,
      currentMentorIndex: 0,
      audioInstance: null,
      context: null,
      oral_challenge_threshold: 5,
      isStarted: false,
      mentors: [
        {
          id: 10,
          name: 'Tina',
          tts_name: 'Ruth',
          accent: '美國腔',
          accent_value: 'en-US',
          gender: '女性',
          gender_value: 'female',
          personality: '鼓勵學習',
          tone: '引導式回應',
          img: require('@/assets/image/ai/course/ai_teacher_Tina.png'),
          audio_url: require('@/assets/image/ai/course/Tina.mp3'),
          audio_text: 'Nice try. Let’s improve this sentence so you can use it right away.'
        },
        {
          id: 1,
          name: 'Michael',
          tts_name: 'Stephen',
          accent: '美國腔',
          accent_value: 'en-US',
          gender: '男性',
          gender_value: 'male',
          personality: '自信專業',
          tone: '正向有精神',
          img: require('@/assets/image/ai/course/ai_teacher_Michael.png'),
          audio_url: require('@/assets/image/ai/course/Michael.mp3'),
          audio_text: 'Let’s get straight to the point and make your message clear and confident.'
        },
        {
          id: 2,
          name: 'Sarah',
          tts_name: 'Amy',
          accent: '英國腔',
          accent_value: 'en-GB',
          gender: '女性',
          gender_value: 'female',
          personality: '開朗大方',
          tone: '引導式回應',
          img: require('@/assets/image/ai/course/ai_teacher_Sarah.png'),
          audio_url: require('@/assets/image/ai/course/Sarah.mp3'),
          audio_text: 'Great start. Let me guide you to say this more naturally in English.'
        },
        {
          id: 3,
          name: 'Chloe',
          tts_name: 'Olivia',
          accent: '澳洲腔',
          accent_value: 'en-AU',
          gender: '女性',
          gender_value: 'female',
          personality: '親切友善',
          tone: '鼓勵支持',
          img: require('@/assets/image/ai/course/ai_teacher_Chloe.png'),
          audio_url: require('@/assets/image/ai/course/Chloe.mp3'),
          audio_text: 'You’re doing well. Let’s try saying it again, just a little more smoothly.'
        },
        // {
        //   id: 4,
        //   name: 'Noah',
        //   tts_name: '',
        //   accent: '加拿大腔',
        //   accent_value: 'en-CA',
        //   gender: '男性',
        //   gender_value: 'male',
        //   personality: '陽光隨和',
        //   tone: '穩定正向',
        //   img: require('@/assets/image/ai/course/ai_teacher_Noah.png'),
        //   // audio_url: require('@/assets/image/ai/course/Noah.mp3'),
        //   audio_text: 'That sounds good already. Here’s a simple way to make it even clearer.'
        // },
        {
          id: 5,
          name: 'Anaya',
          tts_name: 'Kajal',
          accent: '印度腔',
          accent_value: 'en-IN',
          gender: '女性',
          gender_value: 'female',
          personality: '親切細膩',
          tone: '自然不拘謹',
          img: require('@/assets/image/ai/course/ai_teacher_Anaya.png'),
          audio_url: require('@/assets/image/ai/course/Anaya.mp3'),
          audio_text: 'Take your time. Say it naturally, and I’ll help you fine-tune it.'
        },
        {
          id: 6,
          name: 'Emily',
          tts_name: 'Danielle',
          accent: '美國腔',
          accent_value: 'en-US',
          gender: '女性',
          gender_value: 'female',
          personality: '樂於助人',
          tone: '溫暖回應',
          img: require('@/assets/image/ai/course/ai_teacher_Emily.png'),
          audio_url: require('@/assets/image/ai/course/Emily.mp3'),
          audio_text: 'No worries at all. Let’s work on this together, step by step.'
        },
        // {
        //   id: 7,
        //   name: 'Liam',
        //   accent: '澳洲腔',
        //   accent_value: 'en-AU',
        //   gender: '男性',
        //   gender_value: 'male',
        //   personality: '幽默親和',
        //   tone: '輕鬆自然',
        //   img: require('@/assets/image/ai/course/ai_teacher_Liam.png'),
        //   // audio_url: require('@/assets/image/ai/course/Liam.mp3'),
        //   audio_text: 'Relax, you’re on the right track. Let’s make it sound more natural.'
        // },
        // {
        //   id: 8,
        //   name: 'Olivia',
        //   accent: '加拿大腔',
        //   accent_value: 'en-CA',
        //   gender: '女性',
        //   gender_value: 'female',
        //   personality: '謹慎專注',
        //   tone: '沉穩清楚',
        //   img: require('@/assets/image/ai/course/ai_teacher_Olivia.png'),
        //   // audio_url: require('@/assets/image/ai/course/Olivia.mp3'),
        //   audio_text: 'This is clear. Now let’s organize it so it works well in a business setting.'
        // },
        {
          id: 9,
          name: 'James',
          tts_name: 'Arthur',
          accent: '英國腔',
          accent_value: 'en-GB',
          gender: '男性',
          gender_value: 'male',
          personality: '溫文儒雅',
          tone: '結構化清楚',
          img: require('@/assets/image/ai/course/ai_teacher_James.png'),
          audio_url: require('@/assets/image/ai/course/James.mp3'),
          audio_text: 'Your idea is good. Let me help you express it in a clear, structured way.'
        },
        // {
        //   id: 11,
        //   name: 'Raj',
        //   accent: '印度腔',
        //   accent_value: 'en-IN',
        //   gender: '男性',
        //   gender_value: 'male',
        //   personality: '樂於助人',
        //   tone: '自然順暢',
        //   img: require('@/assets/image/ai/course/ai_teacher_Raj.png'),
        //   // audio_url: require('@/assets/image/ai/course/Raj.mp3'),
        //   audio_text: 'That’s understandable. Let’s practice it once more to make it smoother.'
        // }
      ]
    };
  },
  watch: {
    // 當更換導師時，確保先停止正在播放的聲音
    currentMentorIndex() {
      this.audio_stop();
    }
  },
  computed: {
    ...mapGetters([
      'selectedAccent'
    ]),
    targetCourseId () {
      return this.courseId || this.$route.params.courseId
    },
    currentMentor () {
      return this.mentors[this.currentMentorIndex]
    },
    lessonId () {
      return this.$route.params.lesson
    }
  },
  async mounted () {
    this.initMentor()
    this.initAudio()
    this.getCategories()
    // this.getLessonId(this.lessonId)
  },
  methods: {
    initMentor () {
      this.$store.dispatch('setAccent', this.currentMentor.accent_value)
      this.$store.dispatch('setGender', this.currentMentor.gender_value)
    },
    initAudio () {
      // 如果還沒有建立過 Audio 物件，才建立一次
      if (!this.audioInstance) {
        this.audioInstance = new Audio();

        // 事件監聽只綁定這一次
        this.audioInstance.addEventListener('ended', () => {
          this.audio_stop();
        });
      }
    },
    getCategories (fromQuery = false) {
      const path = `/ai/categories/${this.targetCourseId}`
      const options = { headers: { showLoading: fromQuery } }

      api.get(path, options)
        .then((res) => {
          this.context = res.data.data
          this.oral_challenge_threshold = res.data.oral_challenge_threshold || 0
        })
        .catch(err => {
          console.error(err)
        })
    },
    forceToJap (sent, hidePinyin = false) {
      if (!sent) return
      const split = sent.split(/{(.+?)}/)
      let newSent = ''
      for (const i in split) {
        if (split[i].indexOf('=') > -1) {
          if (!hidePinyin) {
            newSent += '<ruby>' + split[i].split(/=/)[0] + '<rt>' + split[i].split(/=/)[1] + '</rt></ruby>'
          } else {
            newSent += split[i].split(/=/)[0]
          }
        } else {
          newSent += split[i]
        }
      }
      return newSent
    },
    playPreviewAudio(audioUrl) {
      this.initAudio(); // 確保 Audio 實體已建立
      // 每次點擊都直接替換 src 並播放
      this.audioInstance.src = audioUrl;
      this.audioInstance.play().catch(error => {
        console.log('試聽播放失敗:', error);
      });
    },
    openMentorPicker() {
      const self = this
      let tempSelectedIndex = self.currentMentorIndex || 0

      const mentorListHtml = self.mentors.map((m, index) => {
      const isActive = index === tempSelectedIndex ? 'active' : ''
      const speakerIconHtml = m.audio_url
          ? `<i class="fas fa-volume-up speaker-icon" style="color: #e5413c; font-size: 0.9rem; margin-left: auto;"></i>`
          : '';
      return `
        <div class="mentor-item ${isActive}" data-index="${index}" style="cursor: pointer; display: flex; align-items: center; padding: 12px; margin-bottom: 12px; border: 2px solid transparent; border-radius: 10px; background: #fff; transition: 0.2s;">
          <img src="${m.img}" style="width: 60px; height: 60px; border-radius: 8px; margin-right: 15px; object-fit: cover;">
          <div style="flex-grow: 1; text-align: left;">
            <div style="font-weight: bold; font-size: 1.1rem; color: #333;">${m.name}</div>
            <div style="display: flex; gap: 5px; margin-top: 5px;">
              <span class="m-tag label-icon">${m.accent}</span>
              <span class="m-tag label-icon">${m.gender}</span>
              <span class="m-tag label-icon">${m.personality}</span>
            </div>
          </div>
          ${speakerIconHtml} </div>
      `;
      }).join('')

      this.$swal({
        title: '選擇AI導師',
        html: `<div id="swal-mentor-list" class="mentor-container" style="max-height: 400px; overflow-y: auto; padding: 20px; background: #f8f9fa;">${mentorListHtml}</div>`,
        showCloseButton: true,
        showConfirmButton: true,
        confirmButtonText: '確認',
        width: '500px',
        customClass: {
          container: 'mentor-swal-container',
          popup: 'mentor-swal-popup max-w-xl w-100',
          title: 'pt-0',
          header: 'mentor-swal-header',
          confirmButton: 'mentor-swal-confirm',
          closeButton: 'position-absolute top-0'
        },
        willClose: () => {
          self.audio_stop()
        },
        didRender: () => {
          const container = document.getElementById('swal-mentor-list');
          container.addEventListener('click', (e) => {
            // 找到被點擊的整行 mentor-item
            const item = e.target.closest('.mentor-item');
            if (!item) return;

            // 取得這行對應的 index
            const clickedIndex = parseInt(item.getAttribute('data-index'));

            // 🌟 新增判斷：如果點擊的是喇叭 icon
            if (e.target.closest('.speaker-icon')) {
              // 拿到這個人的資料並播放試聽音檔
              const mentor = self.mentors[clickedIndex];
              self.playPreviewAudio(mentor.audio_url);
              // return; // 👈 如果你希望「點喇叭只試聽，不要順便選中他」，就把這行註解打開
            }

            // --- 下面是你原本的 UI 切換邏輯 ---
            container.querySelectorAll('.mentor-item').forEach(el => {
              el.style.borderColor = 'transparent';
              el.classList.remove('active');
            });
            item.style.borderColor = '#e5413c';
            item.classList.add('active');

            // 更新暫存 Index
            tempSelectedIndex = clickedIndex;
          });
        },
        preConfirm: () => {
          return tempSelectedIndex;
        }
      }).then((result) => {
        if (result.isConfirmed) {
          const selectedIndex = result.value
          self.currentMentorIndex = selectedIndex
          const selectedMentor = self.mentors[selectedIndex]
          this.$store.dispatch('setAccent', selectedMentor.accent_value)
          this.$store.dispatch('setGender', selectedMentor.gender_value)
        }
      });
    },
    async getLesson (id) {
      const { data } = await api.get(`/contents/lesson/${id}`)
      this.lesson = data.data
    },
    async getLessonId (id) {
      const { data } = await api.get(`/contents/courses/${id}`)
      if (data.status === 'Success') {
        this.lesson = data.data
        this.favorite = data.data.is_favorite
        this.parentId = data.data.package_course.id
        this.cover = data.data.cover
        return data.data
      }
    },
    beginCourse () {
      this.audio_stop()
      this.isStarted = true
    },
    audio_play() {
        this.initAudio();

        // 將目前的音樂路徑塞給 Audio 物件
        // 加個判斷，避免重複載入相同的音樂
        if (this.audioInstance.src !== this.currentMentor.audio_url) {
          this.audioInstance.src = this.currentMentor.audio_url;
        }

        this.audioInstance.play().catch(error => {
          console.log('播放失敗:', error);
        });
      },

    audio_stop() {
      if (this.audioInstance) {
        this.audioInstance.pause();
        this.audioInstance.currentTime = 0; // 回到起點
      }
    }
  }

}
</script>

<style lang="scss" scoped>
.main-content {
  max-width: 1280px;
}

.section-title {
  border-left: 4px solid #d9534f;
  padding-left: 10px;
  font-weight: bold;
  margin-bottom: 12px;
}

.avatar-img {
  width: 80px;
  height: 80px;
  object-fit: cover;
}

.audio-icon {
  position: absolute;
  bottom: -5px;
  right: -5px;
  background: #d9534f;
  color: white;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  border: 2px solid white;
}

.custom-badge {
  background-color: #f0f2f5;
  color: #7d8ea1;
  padding: 5px 12px;
  font-weight: normal;
  border: 1px solid #dee2e6;
}

.custom-list {
  padding-left: 20px;
}

.custom-list li {
  margin-bottom: 10px;
  color: #333;
}

.start-btn {
  background-color: #e5413c;
  border: none;
  min-width: 200px;
}

.cursor-pointer {
  cursor: pointer;
}
/* Swat 彈窗主體客製化 */
.mentor-swal-popup {
  padding: 0 !important;
  border-radius: 8px !important;
  overflow: hidden;
}

/* 紅色標題列 */
.mentor-swal-header {
  background-color: #e5413c;
  color: white;
  padding: 15px !important;
}
.mentor-swal-popup .swal2-title {
  color: white !important;
  font-size: 1.25rem !important;
  margin: 0 !important;
}
.mentor-swal-popup .swal2-close {
  color: white !important;
}

/* 導師列表容器 */
.mentor-container {
  max-height: 400px;
  overflow-y: auto;
  padding: 20px;
  background-color: #f8f9fa;
}

/* 單個導師卡片 */
.mentor-card {
  display: flex;
  align-items: center;
  background: white;
  border: 2px solid transparent;
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 12px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
  cursor: pointer;
  transition: all 0.2s;
}

/* 選中狀態 */
.mentor-card.active {
  border-color: #e5413c;
  box-shadow: 0 0 10px rgba(229, 65, 60, 0.2);
}

.mentor-avatar {
  width: 60px;
  height: 60px;
  border-radius: 8px;
  margin-right: 15px;
}

.mentor-name {
  font-weight: bold;
  font-size: 1.1rem;
  text-align: left;
}

.tag-group {
  display: flex;
  gap: 5px;
  margin-top: 5px;
}

.m-tag {
  font-size: 0.75rem;
  color: #7d8ea1;
  background: #f0f2f5;
  border: 1px solid #dee2e6;
  padding: 2px 8px;
  border-radius: 4px;
}

.speaker-icon {
  margin-left: auto;
  color: #e5413c;
  font-size: 0.9rem;
}

/* 確認按鈕 */
.mentor-swal-confirm {
  background-color: #ff0000 !important;
  width: 60% !important;
  border-radius: 8px !important;
  margin-bottom: 20px !important;
}
/* 讓卡片看起來可以點擊 */
.mentor-item {
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none; /* 避免點擊太快選到文字 */
}

/* 懸停效果 */
.mentor-item:hover {
  background-color: #fcfcfc;
  border-color: #eee;
}

/* 選中效果 (對齊圖片中的紅框) */
.mentor-item.active {
  border: 2px solid #e5413c !important;
  background-color: #fff;
  box-shadow: 0 2px 10px rgba(229, 65, 60, 0.1);
}

/* 喇叭圖示點擊微感 */
.speaker-icon:active {
  transform: scale(1.2);
  opacity: 0.7;
}
.label-icon {
  border: 1px solid #5A5D9B !important;
  color: #5A5D9B !important;
  background-color: white;
}
</style>
